import { PropTypes } from 'react';

const TableCell = ({ children, className, title }) => (
    <td className={className != null ? `cn-table__item ${className}` : 'cn-table__item'} title={title}>
        {children}
    </td>
);

TableCell.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};


export default TableCell;



// WEBPACK FOOTER //
// ./app/components/table/cell.jsx